import "../BinTransfer/BinTransferMain.css";
import { useState, useEffect, useCallback } from "react";
import {  useSelector } from "react-redux";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  Direct_Price_Change_Update,
  RSP_Status_GETROW,
} from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import GCToggleSearchV1 from "../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import { fExecuteAPI } from "../../Server/Apis";

const DirectPriceChange = () => {

  const locationArr = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const { UserID } = vRdxUserInfo() || {};
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const initObj = {
    ItmCd: "",
    ItemName:"",
    Unit: "",
    Loc: locationArr[0]?.Uid,
    Old_RSP: 0,
    SellPr1: 0,
    Old_RSPVat: 0,
    VATRSP: 0,
    AddiCessAmt: 0,
    TaxPerc: 0,
    VATRSPBF: 0,
    VATRSPAF: 0,
    VATRound: 0,
    ExclVat: 0,
    VATAmt: 0,
  };

  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [formData, setFormData] = useState(initObj);
  const [Unit, setUnit] = useState([]);

  const handleDetailChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleItemSelection = async (ItmCd, Name1,DefUnit="") => {
    setFormData((prev) => ({
      ...prev,
      ItmCd: ItmCd,
      ItemName: Name1,
    }));
    await GetUnitArr(ItmCd,true,DefUnit);
  };

  const validate = () => {
    let isValid = true;

    if (
      formData.ItmCd === "" ||
      formData.ItmCd == undefined ||
      formData.ItmCd === null
    ) {
      fAlertToast("FAILED", "Item Code is required.");
      isValid = false;
      return;
    }

    if (
      formData.Unit === "" ||
      formData.Unit === undefined ||
      formData.Unit === null
    ) {
      fAlertToast("FAILED", `Unit is required `);
      isValid = false;
      return;
    }
    if (
      formData.SellPr1 === 0 ||
      formData.SellPr1 === undefined ||
      formData.SellPr1 === null
    ) {
      fAlertToast("FAILED", `New RSP is required `);
      isValid = false;
      return;
    }

    if (
      formData.VATRSP === 0 ||
      formData.VATRSP === undefined ||
      formData.VATRSP === null
    ) {
      fAlertToast("FAILED", `New RSP Vat is required `);
      isValid = false;
      return;
    }
    return isValid;
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setFormData((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setFormData((obj) => ({
        ...obj,
        [e.target.name]: 0,
      }));
    }
  };
// save data
  const handleUpdate = async () => {
    if (!validate()) return;
    const { ItemName,TaxPerc, AddiCessAmt, Old_RSP, Old_RSPVat, ...rest } = formData;
    const requestPayload = {
      ...rest,
      SellPr1: Number(formData?.SellPr1),
      VATRSP: Number(formData?.VATRSP),
      UserId: UserID,
      IP: vRdxuserInfo?.IP,
    };
    const res = await Direct_Price_Change_Update(
      fcheck_null_undefine_replace_empty(requestPayload)
    );
    if (res?.status === 200){ 
        fAlertToast("SUCCESS", `Updated Successfully`);
        let {Loc,...initRest}=initObj;
        setFormData((prev)=>({...prev,...initRest}));
    }
  };

  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        formData?.ItemName,
        formData?.Loc
      );
      if (vItemSearchFull.length > 0) {
        handleItemSelection(
          vItemSearchFull[0]?.ItmCd,
          vItemSearchFull[0]?.Name1,
          vItemSearchFull[0]?.DefUnit
        );
        setItemToggleDropdown(false);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace" && formData?.ItmCd) {
      setFormData((prev) => ({
        ...prev,
        ItmCd: "",
        ItemName: "",
      }));
    }
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        formData?.Loc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const fGCToggleItemOnRowClick = async (e) => {
    handleItemSelection(e?.row?.ItmCd, e?.row?.Name1,"");
    setItemToggleDropdown(false);
  };

  const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
    let vSeatchVendor = {
      Data: xData,
      Type: xType,
      Loc: xA_Loc,
    };
    const vItemSearch = await fExecuteAPI(
      "SEARCHITEM001_GETROW",
      vSeatchVendor
    );
    if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
      let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSearchGridData(vItemSearchArr);
    } else {
      fAlertToast(
        "FAILED",
        vItemSearch.response.data.message
          ? vItemSearch.response.data.message
          : "Error in SearchItem"
      );
    }
  };
  const GetItemFullSearchArr = async (xItemName, xLoc) => {
    let vItemFullSearchDataObj = {
      anyData: xItemName,
      transType: "F",
      report: "Y",
      loc: xLoc,
    };

    const vItemSearchFull = await fExecuteAPI(
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );
    if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearchFull?.ResultSet?.length > 0) {
        return vItemSearchFull.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearchFull?.Type?.response?.data?.message
          ? vItemSearchFull?.Type?.response?.data?.message
          : "Error in vItemSearchFullArr"
      );
      return [];
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = () => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: formData?.ItemName,
    }));

    if (formData?.ItemName != "") {
      GetSearchItem(
        formData?.ItemName,
        "Any",
        formData?.Loc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const GetUnitArr = async (xItemCode, loaderScreen = true,defUnit) => {
    try {
      const response = await fExecuteAPI(
        "GETITEMUNITS_GETROW",
        { itemCd: xItemCode },
        loaderScreen
      );

      if (response?.Type?.toUpperCase() !== "SUCCESS") {
        throw new Error(
          response?.Type?.response?.data?.message ||
            response?.message ||
            response?.response?.data?.Status ||
            "Error in fetching units"
        );
      }

      const units = response.ResultSet || [];
      if (units.length === 0) return [];

      setUnit(units);
      const unitInput = document.querySelector('[tabindex="2"]');
      if (unitInput) {
        unitInput.focus();
      }
      const defaultUnit = defUnit||units[0]?.Unit;
      setFormData((prev) => ({ ...prev, Unit: defaultUnit}));
      await getCostPrice(xItemCode, defaultUnit);
      return units;
    } catch (error) {
      fAlertToast("FAILED", error.message);
      return [];
    }
  };

  const getCostPrice = async (itemCd, unitId) => {
    try {
      const response = await RSP_Status_GETROW({
        ItmCd: itemCd,
        UnitId: unitId,
        Loc: formData?.Loc,
      });

      if (response?.data?.Type?.toUpperCase() !== "SUCCESS") {
        throw new Error(response?.message || "Error in fetching Cost Price");
      }

      const obj = response.data?.ResultSet[0];

      setFormData((prev) => ({
        ...prev,
        Old_RSP: obj?.RSP?.toFixed(2),
        Old_RSPVat: obj?.VATRSP?.toFixed(2),
        AddiCessAmt: obj?.AddiCessAmt?.toFixed(2),
        TaxPerc: obj?.TaxPerc?.toFixed(2),
      }));
    } catch (error) {
      fAlertToast("FAILED", error.message);
    }
  };

  useEffect(() => {
    const itemNameInput = document.querySelector('[tabindex="1"]');
    if (itemNameInput) {
      itemNameInput.focus();
    }
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const itemToggleElement = event.target.closest(".toggleSearch");
        if (!itemToggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ sItemToggleDropdown]);

  return (
    <>
      <div className="mt-4 ms-3 mb-3">
        <span className="breadcrumb-not-active">Direct Price Change </span>
      </div>
      <Box
        p={2}
        sx={{
          margin: "16px",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          backgroundColor: "white",
        }}
      >
        <Grid container spacing={{ xs: 1.5, md: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography>Location</Typography>
            <FormControl fullWidth>
              <Select
                tabIndex={0}
                size="small"
                value={formData?.Loc}
                onChange={(e) => {
                  handleDetailChange("Loc", e.target.value);
                  let { Loc, ...initRest } = initObj;
                  setFormData((prev) => ({ ...prev, ...initRest }));
                }}
              >
                {locationArr &&
                  locationArr.length > 0 &&
                  locationArr?.map((loc) => (
                    <MenuItem key={loc.Uid} value={loc.Uid}>
                      {loc?.Name1}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Typography>Item Code</Typography>
            <TextField
              value={formData?.ItmCd}
              onChange={(e) => handleDetailChange("ItmCd", e.target.value)}
              sx={{
                bgcolor: "lightgray",
                "& .MuiInputBase-root": {
                  padding: 0, // Removes outer padding
                },
                "& .MuiInputBase-input": {
                  padding: "8.5px 11px", // Removes inner input padding
                },
              }}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={5}>
            <Typography>Item Name</Typography>
            <GCToggleSearchV1
              xLabelText=""
              xtabIndex={1}
              xName="ItmName"
              xType="text"
              xValue={formData?.ItemName}
              xReadOnly={false}
              xOnChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  ItmCd: "",
                  Unit: "",
                  Old_RSP: 0,
                  Old_RSPVat: 0,
                  SellPr1: 0,
                  VATRSP: 0,
                }));
                setUnit([]);
                handleDetailChange("ItemName", e.target.value);
              }}
              xOnKeyUp={fItemSearchKey}
              xonClickbtn={fItemSearchKey}
              xrows={sGridSelectRowData}
              xcolumns={[
                { field: "id", headerName: "ID", width: 70, hide: true },
                { field: "ItmCd", headerName: "Code", width: 90 },
                { field: "Name1", headerName: "Name", flex: 1 },
              ]}
              xRowClick={fGCToggleItemOnRowClick}
              xRowCellClick={fGCToggleItemOnCellKeyDown}
              xToggle={sItemToggleDropdown}
              xData={["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"]}
              xOnChangeDropdownInput={fOnChangeItem}
              xDropdownObj={sItemSearchDropdownObj}
              xOnKeyUpDropdownInput={fOnKeyUpItem}
            />
          </Grid>
          <Grid item xs={9} sm={3} md={2}>
            <Typography>Unit</Typography>
            <FormControl fullWidth>
              <Select
                size="small"
                tabIndex={2}
                value={formData?.Unit}
                name="Unit"
                onChange={(e) => {
                  setFormData((prevV) => ({
                    ...prevV,
                    Unit: e.target.value,
                  }));
                  getCostPrice(formData?.ItmCd, e.target.value);
                }}
                autoComplete="off"
              >
                {Unit.map((val) => (
                  <MenuItem key={val.UOM} value={val.UOM}>
                    {val?.Name1}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={3} sm={1.5} md={1.5} lg={1.2} xl={1}>
            <Typography>Old RSP</Typography>
            <TextField
              size="small"
              type="number"
              value={formData?.Old_RSP}
              disabled
              tabIndex={-1}
            />
          </Grid>
          <Grid item xs={4} sm={1.5} md={1.7} lg={1.2} xl={1}>
            <Typography>Old VAT RSP</Typography>
            <TextField
              size="small"
              type="number"
              value={formData?.Old_RSPVat}
              disabled
              tabIndex={-1}
            />
          </Grid>
          <Grid item xs={4} sm={1.5} md={1.3} lg={1.2} xl={1}>
            {" "}
            <Typography>New RSP</Typography>
            <TextField
              size="small"
              type="number"
              name="SellPr1"
              tabIndex={3}
              value={formData?.SellPr1}
              onChange={(e) => {
                const rsp = parseFloat(e.target.value);
                const taxPerc = parseFloat(formData.TaxPerc);
                const addiCess = parseFloat(formData.AddiCessAmt);

                // Correct VAT and VAT-inclusive RSP calculation
                const vatAmount = rsp * (taxPerc / 100);
                const rspWithVAT = rsp + vatAmount + addiCess;

                setFormData((prev) => ({
                  ...prev,
                  SellPr1: rsp, // VAT-exclusive rsp,
                  VATRSP: parseFloat(rspWithVAT)?.toFixed(2), // VAT-inclusive
                }));
              }}
              onFocus={fContent_Focus}
              onBlur={fContent_Blur}
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={4} sm={2} md={1.7} lg={1.2} xl={1}>
            <Typography> New VAT RSP</Typography>
            <TextField
              size="small"
              type="number"
              tabIndex={4}
              value={formData?.VATRSP}
              name="VATRSP"
              onChange={(e) => {
                const vatRSP = parseFloat(e.target.value);
                const taxPerc = parseFloat(formData.TaxPerc);
                const addiCess = parseFloat(formData.AddiCessAmt);

                // RSP (without VAT and AddiCess)
                const rsp = parseFloat(
                  (vatRSP - addiCess) / (1 + taxPerc / 100)
                );

                setFormData((prev) => ({
                  ...prev,
                  VATRSP: vatRSP,
                  SellPr1: parseFloat(rsp)?.toFixed(4),
                }));
              }}
              onFocus={fContent_Focus}
              onBlur={fContent_Blur}
              inputProps={{ min: 0 }}
            />
          </Grid>
        </Grid>
        <Stack direction="row" sx={{ mt: 2 }} justifyContent={"flex-end"}>
          <Button size="small" variant="contained" onClick={handleUpdate}>
            Save
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default DirectPriceChange;
